import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Endpoints} from "../endpoints";
import {catchError, firstValueFrom} from "rxjs";
import {HelperUtils} from "../../@admin/utils/methods/helper.utils";
import {InternalDocumentationResponseResponse} from "../models/response/internal-documentation-view-response";
import {InternalDocsManageResponseResponse} from "../models/response/internal-documents-manage-response";
import {UpsertModelResponse} from "../models/response/upsert-model-response";
import {CreateUpdateInternalDocumentationRequest} from "../models/request/create-internal-documentation-request";
import {PublicDocsManageResponseResponse} from "../models/response/public-documentation-response";

@Injectable({
  providedIn: 'root'
})
export class DocumentationService {

  constructor(private http: HttpClient, public _endpoint: Endpoints) {
  }


  /**
   * Documentation - View - Get App Left Menu
   * **/
  GetInternalDocumentationLeftMenu(productTypeEnum: number): Promise<InternalDocumentationResponseResponse> {
    const url: string = `${this._endpoint.appendApiBaseUrl(this._endpoint.get_internal_documentation_leftmenu)}${productTypeEnum}`;
    return firstValueFrom(this.http
      .get<InternalDocumentationResponseResponse>(url, {headers: this._endpoint.httpHeader})
      .pipe(catchError(HelperUtils.handleError)));
  }

  /**
   * Internal Documentation By Document ID
   * **/
  GetInternalDocumentationByDocId(documentId: number | null): Promise<InternalDocumentationResponseResponse> {
    const url: string = `${this._endpoint.appendApiBaseUrl(this._endpoint.get_internal_documentation_by_docId)}${documentId}`;
    return firstValueFrom(this.http
      .get<InternalDocumentationResponseResponse>(url, {headers: this._endpoint.httpHeader})
      .pipe(catchError(HelperUtils.handleError)));
  }

  /**
   * Internal Documentation Manage
   * **/
  GetInternalDocumentationList(productTypeEnum: number | null | undefined): Promise<InternalDocsManageResponseResponse> {
    const url: string = `${this._endpoint.appendApiBaseUrl(this._endpoint.get_internal_documentation_list)}${productTypeEnum}`;
    return firstValueFrom(this.http
      .get<InternalDocsManageResponseResponse>(url, {headers: this._endpoint.httpHeader})
      .pipe(catchError(HelperUtils.handleError)));
  }

  /**
   * Delete Internal Documentation
   * **/
  deleteDocument(documentId: number): Promise<UpsertModelResponse> {
    const url = this._endpoint.appendApiBaseUrl(this._endpoint.delete_document) + documentId
    return firstValueFrom(
      this.http.delete<UpsertModelResponse>(url).pipe(catchError(HelperUtils.handleError))
    );
  }

  /**
   * Create Internal Documentation Manage
   * **/
  ManageDocumentCreate(reqBody: CreateUpdateInternalDocumentationRequest): Promise<InternalDocsManageResponseResponse> {
    return firstValueFrom(this.http
      .post<InternalDocsManageResponseResponse>(this._endpoint.appendApiBaseUrl(this._endpoint.create_update_document), JSON.stringify(reqBody), {headers: this._endpoint.httpHeader})
      .pipe(catchError(HelperUtils.handleError)));
  }

  /**
   * Update Internal Documentation Manage
   * **/
  ManageDocumentUpdate(reqBody: CreateUpdateInternalDocumentationRequest): Promise<InternalDocsManageResponseResponse> {
    return firstValueFrom(this.http
      .put<InternalDocsManageResponseResponse>(this._endpoint.appendApiBaseUrl(this._endpoint.create_update_document), JSON.stringify(reqBody), {headers: this._endpoint.httpHeader})
      .pipe(catchError(HelperUtils.handleError)));
  }

  /**
   * Public *
   * **/

  /**
   * Public Documentation List
   * **/
  GetPublicDocumentationList(productTypeEnum: number | null | undefined): Promise<PublicDocsManageResponseResponse> {
    const url: string = `${this._endpoint.appendApiBaseUrl(this._endpoint.get_public_documentation_list)}${productTypeEnum}`;
    return firstValueFrom(this.http
      .get<PublicDocsManageResponseResponse>(url, {headers: this._endpoint.httpHeader})
      .pipe(catchError(HelperUtils.handleError)));
  }

  /**
   * Delete Public Documentation
   * **/
  deletePublicDocument(documentId: number): Promise<UpsertModelResponse> {
    const url = this._endpoint.appendApiBaseUrl(this._endpoint.delete_public_document) + documentId
    return firstValueFrom(
      this.http.delete<UpsertModelResponse>(url).pipe(catchError(HelperUtils.handleError))
    );
  }

  /**
   * Create Public Documentation Manage
   * **/
  ManagePublicDocumentCreate(reqBody: CreateUpdateInternalDocumentationRequest): Promise<PublicDocsManageResponseResponse> {
    return firstValueFrom(this.http
      .post<PublicDocsManageResponseResponse>(this._endpoint.appendApiBaseUrl(this._endpoint.create_update_public_document), JSON.stringify(reqBody), {headers: this._endpoint.httpHeader})
      .pipe(catchError(HelperUtils.handleError)));
  }

  /**
   * Update Public Documentation Manage
   * **/
  ManagePublicDocumentUpdate(reqBody: CreateUpdateInternalDocumentationRequest): Promise<PublicDocsManageResponseResponse> {
    return firstValueFrom(this.http
      .put<PublicDocsManageResponseResponse>(this._endpoint.appendApiBaseUrl(this._endpoint.create_update_public_document), JSON.stringify(reqBody), {headers: this._endpoint.httpHeader})
      .pipe(catchError(HelperUtils.handleError)));
  }

  /**
   *Get Document List and patch value to update
   * **/
  GetDocumentationList(productTypeEnum: number | null | undefined): Promise<PublicDocsManageResponseResponse> {
    const url: string = `${this._endpoint.appendApiBaseUrl(this._endpoint.get_documentation_list)}${productTypeEnum}`;
    return firstValueFrom(this.http
      .get<PublicDocsManageResponseResponse>(url, {headers: this._endpoint.httpHeader})
      .pipe(catchError(HelperUtils.handleError)));
  }
}
